import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const GoogleScheduleWizardPage = lazy(
  () => import('~/features/content-enrichment/pages/google-schedule-wizard-page'),
);

/** `?scheduleId=` edits that schedule's settings; without it a new schedule is set up. */
interface ScheduleWizardSearch {
  scheduleId?: string;
}

/** The Google Ads (GMC) batch wizard in schedule mode.
 *  URL: `/enrichments/google/schedule`. Contract-gated via the parent layout. */
export const Route = createFileRoute('/_authenticated/_tenant/enrichments/google/schedule')({
  validateSearch: (search: Record<string, unknown>): ScheduleWizardSearch =>
    typeof search.scheduleId === 'string' && search.scheduleId
      ? { scheduleId: search.scheduleId }
      : {},
  component: RouteComponent,
});

function RouteComponent() {
  const { scheduleId } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <GoogleScheduleWizardPage {...(scheduleId ? { scheduleId } : {})} />
    </Suspense>
  );
}
